export default [
  {
    path: 'contas-bancarias',
    name: 'bankAccounts',
    component: () => import(/* webpackChunkName: "bankAccounts" */ './Index.vue'),
    meta: {
      title: 'Contas Bancárias',
      icon: 'mdi-bank',
      admin: true
    }
  },
  {
    path: 'contas-bancarias/:id',
    name: 'bankAccounts.view',
    component: () => import(/* webpackChunkName: "bankAccounts" */ './View.vue'),
    meta: {
      title: 'Conta Bancária',
      icon: 'mdi-bank',
      admin: true
    }
  }
];
